import { Button } from '@/components/ui/button';
import { ExternalLink } from 'lucide-react';
import type { GrRewardDelivered } from '@/lib/api';

interface RewardSummaryProps {
  /** Rewards minted on this win, or null if the claim failed (gameplay still succeeded). */
  rewards: GrRewardDelivered[] | null;
}

// arche-id: arche_dfe
const DFE_INVENTORY_URL = '/a/arche_dfe';

function formatRewardLine(reward: GrRewardDelivered): string {
  return `${reward.finalAmount} ${reward.rewardType}`;
}

function joinReadable(parts: string[]): string {
  if (parts.length === 0) return '';
  if (parts.length === 1) return parts[0];
  if (parts.length === 2) return `${parts[0]} and ${parts[1]}`;
  return `${parts.slice(0, -1).join(', ')}, and ${parts[parts.length - 1]}`;
}

export function RewardSummary({ rewards }: RewardSummaryProps) {
  if (!rewards || rewards.length === 0) {
    return null;
  }

  const openInventory = () => {
    window.open(DFE_INVENTORY_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <div
      className="rounded-md border bg-muted/40 p-4 text-center space-y-3"
      data-testid="fiardle-reward-summary"
    >
      <p className="font-semibold">You earned {joinReadable(rewards.map(formatRewardLine))}.</p>
      <p className="text-sm text-muted-foreground">Find your reward in the DFE Inventory arche.</p>
      <Button
        variant="secondary"
        size="sm"
        onClick={openInventory}
        data-testid="open-dfe-inventory-button"
      >
        <ExternalLink className="h-4 w-4 mr-2" />
        Open DFE Inventory
      </Button>
    </div>
  );
}
